import React from "react";
import FormatDate from "../../utils/formatDate";
import "../../assets/scss/intel.scss";
import "../../assets/scss/global.scss";
import { filterTypeDictionary as filterTypeDictionary } from "../../core/dictionary/filter-type";

const main_dropdown_options = [
  { value: "entire_bill_of_lading", label: "All Categories" },
  { value: "product_description", label: "Product" },
  { value: "importers", label: "Consignee" },
  { value: "exporters", label: "Shipper" },
  { value: "product_hscode", label: "HS Code" },
];
const search_type_options = {
  Shipments: "Number of Shipments",
  TEUs: "Total TEUs",
  "Weight (kg)": "Total Weight",
  "% of shipments": "% market share by Shipments",
  "% of TEUs": "% market share by TEUs",
  "% of weight": "% market share by Weight",
};
export const AnalyticsDownloadContent = React.forwardRef((props, ref) => {
  const specialFilterType = {
    [filterTypeDictionary.proximityFilter]: true,
  };
  return (
    <>
      <div ref={ref}>
        {/* Below code for the Header of the PDF */}
        <div>
          <div style={{ width: "auto", clear: "both", margin: 0, fontSize: 14 + "px", fontFamily: "Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif", color: "#1a1722" }}>
            <table cellPadding="0" cellSpacing="0" style={{ width: 100 + "%", lineHeight: "inherit", textAlign: "left", borderSpacing: 0 + "px" }}>
              <tbody>
                <tr style={{ backgroundColor: "#271c45" }}>
                  <td colSpan="1" style={{ width: 70 + "%", color: "#ffffff", fontSize: 16 + "px", padding: 20 + "px", verticalAlign: "top", borderSpacing: 0 + "px" }}>
                    <a href="https://www.trademo.com/" target="_blank" rel="noopener noreferrer">
                      <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1644470254/global/trademo_logo/logo_purple_img3zz.svg" alt="trademo" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* End of the above code */}
        {/* Below code is the heading of the PDF */}
        <div>
          <h1 style={{ color: "black", fontSize: 24 + "px", textAlign: "center", marginTop: 30 + "px" }}> Analytics Report</h1>
        </div>
        {/* End of the above code */}
        {/* Below is the code for the table of the Search Criteria and Filters */}
        <div style={{ width: "auto", clear: "both", margin: 0, fontSize: 14 + "px", fontFamily: "Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif", color: "#1a1722", paddingTop: 0 }}>
          <table cellPadding="0" cellSpacing="0" style={{ width: 100 + "%", lineHeight: "inherit", textAlign: "left", borderSpacing: 0 + "px" }}>
            <tr>
              <td colSpan="3" style={{ padding: 10 + "px", borderBottom: 1 + "px solid #eaeaea" }}>
                <table cellPadding="0" cellSpacing="0" style={{ width: 100 + "%", lineHeight: "inherit", textAlign: "left" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: 50 + "%", verticalAlign: "top" }}>
                        <table cellPadding="0" cellSpacing="0" style={{ width: 100 + "%", lineHeight: "inherit", textAlign: "left", padding: 0, border: 1 + "px solid #eaeaea", borderRadius: 8 + "px", borderTop: "none", borderBottom: "none", borderSpacing: 0 + "px" }}>
                          <tbody>
                            <tr>
                              <td style={{ width: 30 + "%", verticalSlign: "middle", background: "#eaeaea", borderBottom: 1 + "px solid #ddd", fontWeight: "bold", fontSize: 14 + "px", padding: 6 + "px", lineHeight: 1.5, borderTopLeftRadius: 8 + "px" }}>
                                <img style={{ verticalAlign: "middle" }} src="https://res.cloudinary.com/drzta9shk/image/upload/v1664188894/intel/analytics/tune_xdhtnr.svg" alt="..." />
                                &nbsp;&nbsp;Search Criteria and Filters
                              </td>
                              <td style={{ width: 70 + "%", verticalAlign: "middle", background: "#eaeaea", borderBottom: 1 + "px solid #ddd", fontWeight: "bold", fontSize: 14 + "px", padding: 6 + "px", lineHeight: 1.5, borderTopRightRadius: 8 + "px" }}></td>
                            </tr>
                            <tr>
                              <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>Search Type</td>
                              <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>
                                {!!props.analyticsData.analyticsData.searchType && props.analyticsData.analyticsData.searchType.toLowerCase() === "basic" ? "Primary" : props.analyticsData.analyticsData.searchType}
                                {!!props.analyticsData.analyticsData.search_type && props.analyticsData.analyticsData.search_type.toLowerCase() === "basic" ? "Primary" : props.analyticsData.analyticsData.search_type}
                              </th>
                            </tr>
                            <tr>
                              <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>Search Category and Phrase</td>
                              <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>
                                {props.analyticsData.analyticsData.searchKey ? (
                                  <>
                                    {props.analyticsData.analyticsData.searchKey === main_dropdown_options[0].value ? (
                                      <span>
                                        {main_dropdown_options[0].label} - "{props.analyticsData.analyticsData.searchString ? props.analyticsData.analyticsData.searchString.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                    {props.analyticsData.analyticsData.searchKey === main_dropdown_options[1].value ? (
                                      <span>
                                        {main_dropdown_options[1].label} - "{props.analyticsData.analyticsData.searchString ? props.analyticsData.analyticsData.searchString.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                    {props.analyticsData.analyticsData.searchKey === main_dropdown_options[2].value ? (
                                      <span>
                                        {main_dropdown_options[2].label} - "{props.analyticsData.analyticsData.searchString ? props.analyticsData.analyticsData.searchString.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                    {props.analyticsData.analyticsData.searchKey === main_dropdown_options[3].value ? (
                                      <span>
                                        {main_dropdown_options[3].label} - "{props.analyticsData.analyticsData.searchString ? props.analyticsData.analyticsData.searchString.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                    {props.analyticsData.analyticsData.searchKey === main_dropdown_options[4].value ? (
                                      <span>
                                        {main_dropdown_options[4].label} - "{props.analyticsData.analyticsData.searchString ? props.analyticsData.analyticsData.searchString.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                  </>
                                ) : props.analyticsData.analyticsData.key ? (
                                  <>
                                    {props.analyticsData.analyticsData.key === main_dropdown_options[0].value ? (
                                      <span>
                                        {main_dropdown_options[0].label} - "{props.analyticsData.analyticsData.search ? props.analyticsData.analyticsData.search.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                    {props.analyticsData.analyticsData.key === main_dropdown_options[1].value ? (
                                      <span>
                                        {main_dropdown_options[1].label} - "{props.analyticsData.analyticsData.search ? props.analyticsData.analyticsData.search.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                    {props.analyticsData.analyticsData.key === main_dropdown_options[2].value ? (
                                      <span>
                                        {main_dropdown_options[2].label} - "{props.analyticsData.analyticsData.search ? props.analyticsData.analyticsData.search.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                    {props.analyticsData.analyticsData.key === main_dropdown_options[3].value ? (
                                      <span>
                                        {main_dropdown_options[3].label} - "{props.analyticsData.analyticsData.search ? props.analyticsData.analyticsData.search.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                    {props.analyticsData.analyticsData.key === main_dropdown_options[4].value ? (
                                      <span>
                                        {main_dropdown_options[4].label} - "{props.analyticsData.analyticsData.search ? props.analyticsData.analyticsData.search.split("||").map((item, i) => (i !== 0 ? " | " + item.split("|")[0] : item.split("|")[0])) : "Blank Search"}"
                                      </span>
                                    ) : (
                                      <span></span>
                                    )}
                                  </>
                                ) : (
                                  <></>
                                )}
                              </th>
                            </tr>
                            <tr>
                              <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>Match Type</td>
                              <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>
                                {props.analyticsData.analyticsData.queryType === "contains" ? <span>Contains</span> : <></>}
                                {props.analyticsData.analyticsData.queryType === "exact" ? <span>Exact phrase matches</span> : <></>}
                              </th>
                            </tr>
                            <tr>
                              <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>Analysis Based On</td>
                              <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>{!!search_type_options[props.analyticsData.mainLabel] && search_type_options[props.analyticsData.mainLabel] !== "" ? search_type_options[props.analyticsData.mainLabel] : ""}</th>
                            </tr>
                            <tr>
                              <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>Date Range</td>
                              <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>
                                {FormatDate(props.analyticsData.analyticsData.fromDate, "MMM DD, YYYY")} To {FormatDate(props.analyticsData.analyticsData.toDate, "MMM DD, YYYY")}
                              </th>
                            </tr>
                            {!!props && !!props.analyticsData && !!props.analyticsData.filterList && props.analyticsData.filterList.length !== 0 ? (
                              <>
                                {props.analyticsData.filterList.map((item) => {
                                  return (
                                    <>
                                      {specialFilterType[item.type] === true ? (
                                        <>
                                          {!!props && !!props.analyticsData && !!props.analyticsData.analyticsData[item.key] && props.analyticsData.analyticsData[item.key].length > 0 ? (
                                            <tr>
                                              <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>
                                                {item.label}
                                                {props.analyticsData.includeFilter && props.analyticsData.includeFilter.includes(item.key) ? " (Included)" : props.analyticsData.excludeFilter && props.analyticsData.excludeFilter.includes(item.key) ? " (Excluded)" : ""}
                                              </td>
                                              <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>
                                                {props.analyticsData.analyticsData[item.key].map((data, i) => (
                                                  <>
                                                    {data} {i !== props.analyticsData.analyticsData[item.key].length - 1 ? <span>, </span> : <></>}
                                                  </>
                                                ))}
                                              </th>
                                            </tr>
                                          ) : (
                                            <></>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {!!props && !!props.analyticsData && !!props.analyticsData.appliedState[item.key] && props.analyticsData.appliedState[item.key].length > 0 ? (
                                            <tr>
                                              <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>
                                                {item.label}
                                                {props.analyticsData.includeFilter && props.analyticsData.includeFilter.includes(item.key) ? " (Included)" : props.analyticsData.excludeFilter && props.analyticsData.excludeFilter.includes(item.key) ? " (Excluded)" : ""}
                                              </td>
                                              <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>
                                                {props.analyticsData.appliedState[item.key].map((data, i) => (
                                                  <>
                                                    {data} {i !== props.analyticsData.appliedState[item.key].length - 1 ? <span>, </span> : <></>}
                                                  </>
                                                ))}
                                              </th>
                                            </tr>
                                          ) : (
                                            <></>
                                          )}
                                        </>
                                      )}
                                    </>
                                  );
                                })}
                              </>
                            ) : (
                              <></>
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>
        </div>
        {/* End of the above code */}
        {/* Below code is for the content next page push */}
        <div style={{ display: "block", pageBreakAfter: "always" }} />
        {/* End of the above code */}
        {/* Below code is for the Table for the Cards Component */}
        <div style={{ width: "auto", clear: "both", margin: 0, fontSize: 14 + "px", fontFamily: "Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif", color: "#1a1722", paddingTop: 0 }}>
          <table cellPadding="0" cellSpacing="0" style={{ width: 100 + "%", lineHeight: "inherit", textAlign: "left", borderSpacing: 0 + "px" }}>
            <tr>
              <td colSpan="3" style={{ paddingLeft: 20 + "px", paddingRight: 20 + "px", paddingTop: 7 + "px" }}>
                <table cellPadding="0" cellSpacing="0" style={{ width: 100 + "%", lineHeight: "inherit", textAlign: "left" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: 50 + "%", verticalAlign: "top" }}>
                        <table cellPadding="0" cellSpacing="0" style={{ width: 100 + "%", lineHeight: "inherit", textAlign: "left", padding: 0, border: 1 + "px solid #eaeaea", borderRadius: 8 + "px", borderTop: "none", borderBottom: "none", borderSpacing: 0 + "px" }}>
                          <tbody>
                            <tr>
                              <td style={{ width: 30 + "%", verticalSlign: "middle", background: "#eaeaea", borderBottom: 1 + "px solid #ddd", fontWeight: "bold", fontSize: 14 + "px", padding: 6 + "px", lineHeight: 1.5, borderTopLeftRadius: 8 + "px" }}>
                                <img style={{ verticalAlign: "middle" }} src="https://res.cloudinary.com/drzta9shk/image/upload/v1665053041/intel/analytics/format_list_bulleted_yytxbg.svg" alt="..." />
                                &nbsp;&nbsp;Analytics Macro's
                              </td>
                              <td style={{ width: 70 + "%", verticalAlign: "middle", background: "#eaeaea", borderBottom: 1 + "px solid #ddd", fontWeight: "bold", fontSize: 14 + "px", padding: 6 + "px", lineHeight: 1.5, borderTopRightRadius: 8 + "px" }}></td>
                            </tr>
                            {!!props && !!props.analyticsData && !!props.analyticsData.analyticsCommonData && !!props.analyticsData.analyticsCommonData.total_shipments && props.analyticsData.analyticsCommonData.total_shipments !== "" ? (
                              <tr>
                                <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>Total Shipments {!!props && !!props.analyticsData && !!props.analyticsData.redirectingURL && props.analyticsData.redirectingURL !== "" && props.analyticsData.redirectingURL.includes("export") === true ? "Exported" : "Imported"}</td>
                                <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>{props.analyticsData.analyticsCommonData.total_shipments}</th>
                              </tr>
                            ) : (
                              <></>
                            )}
                            {!!props && !!props.analyticsData && !!props.analyticsData.analyticsCommonData && !!props.analyticsData.analyticsCommonData.total_teu && props.analyticsData.analyticsCommonData.total_teu !== "" ? (
                              <tr>
                                <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>Total TEUs</td>
                                <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>{props.analyticsData.analyticsCommonData.total_teu}</th>
                              </tr>
                            ) : (
                              <></>
                            )}
                            {!!props && !!props.analyticsData && !!props.analyticsData.analyticsCommonData && !!props.analyticsData.analyticsCommonData.total_weight && props.analyticsData.analyticsCommonData.total_weight !== "" ? (
                              <tr>
                                <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>Total Shipments Weight</td>
                                <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>{props.analyticsData.analyticsCommonData.total_weight}</th>
                              </tr>
                            ) : (
                              <></>
                            )}
                            {!!props && !!props.analyticsData && !!props.analyticsData.analyticsCommonData && !!props.analyticsData.analyticsCommonData.total_value && props.analyticsData.analyticsCommonData.total_value !== "" ? (
                              <tr>
                                <td style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>Total Shipments Value</td>
                                <th style={{ borderBottom: 1 + "px solid #eaeaea", padding: 6 + "px", lineHeight: 1.5, fontSize: 14 + "px" }}>{props.analyticsData.analyticsCommonData.total_value}</th>
                              </tr>
                            ) : (
                              <></>
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>
        </div>
        {/* End of the above code */}
        {/* Below code is for the Analtics Component */}
        <div style={{ paddingTop: 5 + "px", paddingLeft: 20 + "px", paddingRight: 20 + "px" }}>
          <div dangerouslySetInnerHTML={{ __html: props.analyticsData.domElement }}></div>
        </div>
        {/* End of the above code */}
      </div>
    </>
  );
});

AnalyticsDownloadContent.displayName = "AnalyticsDownloadContent";
